import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

export const DEFAULT_STATUS_CODE = 200;

export type TRouteErrorCallback = (error: Error | any, url: string) => void;

export const useStatusCode = (
  initialStatusCode = DEFAULT_STATUS_CODE,
  routeErrorCallback: undefined | TRouteErrorCallback = undefined
): [
  statusCode: number | undefined,
  setNewStatusCode: (newStatusCode: number | undefined) => void
] => {
  const router = useRouter();

  const [newStatusCode, setNewStatusCode] =
    useState<number | undefined>(initialStatusCode);

  useEffect(() => {
    const handleRouteChangeComplete = () => {
      setNewStatusCode(DEFAULT_STATUS_CODE);
    };
    // this could be creating doulbe pvs.
    // this routes CSR fails, tracks here, then Next lets the underlying <a href run and the pv gets tracked via SSR pageload
    const handleRouteChangeError = (error, url) => {
      if (error.cancelled) return;

      if (routeErrorCallback) routeErrorCallback(error, url);

      setNewStatusCode(999);
    };

    router.events.on('routeChangeComplete', handleRouteChangeComplete);
    router.events.on('routeChangeError', handleRouteChangeError);

    return () => {
      router.events.off('routeChangeComplete', handleRouteChangeComplete);
      router.events.off('routeChangeError', handleRouteChangeError);
    };
  }, [router.events, routeErrorCallback]);

  return [newStatusCode, setNewStatusCode];
};
